(function () {
    'use strict';
    app.service('UpgradeService', ['$http', '$q', '$rootScope',
    function ($http, $q, $rootScope) {

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deviceInfo = [];
        var deferred;

        this.save = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/subscription/updatepurchasepackage", data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.paymentDecline = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/subscription/updatepaymentdecline", data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        //this.getSubscriptionData = function (data) {

        //    deferred = $q.defer();

        //    $http.get(serviceBase + "api/subscription/getSubscription?userId=" + data)
        //    .then(function (response) {
        //        deferred.resolve(response);
        //    })
        //    .catch(function (err) {
        //        deferred.resolve(err);
        //    });

        //    return deferred.promise;
        //}

        this.getSelectedPackageById = function (packId, ownerId) {
            deferred = $q.defer();

            $http.get(serviceBase + "api/subscription/getPackageById?packId=" + packId + "&ownerId=" + ownerId)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }



        this.getSubscriptionProducts = function () {
            deferred = $q.defer();

            $http.get(serviceBase + "api/subscription/getProducts")
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.setLicenseKeyStatus = function (memberList, userId, startDate, endDate, packId) {
            deferred = $q.defer();

            return $http({
                method: "POST",
                url: serviceBase + "api/subscription/assignLicenceStatus/" + userId + "/" + startDate + "/" + endDate + "/" + packId,
                dataType: 'json',
                data: memberList,
                headers: { 'Content-Type': 'application/json' }
            }).success(function (data, headers, status) {

                deferred.resolve(data);
            }).error(function (err, status) {

                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.sendPurchaseNotification = function (emailId, productName, amountCharged, startDate, endDate, isInstitution, isMonthly, firstName, isAutorenewal) {
            deferred = $q.defer();

            return $http({
                method: "POST",
                url: serviceBase + "api/subscription/sendPurchaseNotification/" + emailId + "/" + productName + "/" + amountCharged + "/" + startDate + "/" + endDate + "/" + isInstitution + "/" + isMonthly + "/" + firstName + "/" + isAutorenewal,
                dataType: 'json',
                headers: { 'Content-Type': 'application/json' }
            }).success(function (data, headers, status) {

                deferred.resolve(data);
            }).error(function (err, status) {

                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.sendLicenseNotification = function (memberList, adminEmail, startDate, endDate) {
            return $http({
                method: "POST",
                url: serviceBase + "api/subscription/sendlicencenotification/" + adminEmail + "/" + startDate + "/" + endDate,
                dataType: 'json',
                data: memberList,
                headers: { 'Content-Type': 'application/json' }
            }).success(function (data, headers, status) {

            }).error(function (err, status) {

            });
        };

        this.getSignature = function (upgradeData) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/subscription/purchasepackage/", upgradeData, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getTeamSignature = function (upgradeData) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/subscription/teamPurchasepackage/", upgradeData, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getcountryData = function () {
            deferred = $q.defer();

            $http.get(serviceBase + "country")
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getstateData = function (code) {
            deferred = $q.defer();

            $http.get(serviceBase + 'state?AipCountryID=0&AipCountryCode=' + code + '')
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.updateCCDetails = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/subscription/updateCCDetails", data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.sendUpdateCCNotification = function (cardNumber, firstName) {
            deferred = $q.defer();

            return $http({
                method: "POST",
                url: serviceBase + "api/subscription/sendUpdateCCNotification/"+ cardNumber + "/" + firstName,
                dataType: 'json',
                headers: { 'Content-Type': 'application/json' }
            }).success(function (data, headers, status) {

                deferred.resolve(data);
            }).error(function (err, status) {

                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.getSubscriptionConfirmationDetails = function (transId) {
            deferred = $q.defer();

            return $http({
                method: "GET",
                url: serviceBase + "api/subscription/getSubscriptionConfirmationDetails/" + transId,
                dataType: 'json',
                headers: { 'Content-Type': 'application/json' }
            }).success(function (data, headers, status) {

                deferred.resolve(data);
            }).error(function (err, status) {

                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.validateCoupon = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/subscription/validateCoupon", data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }
    }
    ]);
})();